import { CommonService } from './../../base-services/common.service';
import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { padNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
import { UserService } from '../../base-services/user.service';
@Injectable()
export class NgbDateSrParserFormatter extends NgbDateParserFormatter{
    constructor(private commonService: CommonService,
                private userService: UserService){
        super();
    }
    parse(value: string): NgbDateStruct{
        if(value){
            const dateParts = value.trim().split(this.userService.GetDateSeparator());
            if(dateParts.length === 1 && this.commonService.IsNumber(dateParts[0])){
                return { day: this.commonService.ToInteger(dateParts[0]), month: null, year: null };
            }
            else if(dateParts.length === 2 && this.commonService.IsNumber(dateParts[0]) && this.commonService.IsNumber(dateParts[1])){
                return { day: this.commonService.ToInteger(dateParts[0]), month: this.commonService.ToInteger(dateParts[1]), year: null };
            }
            else if(dateParts.length === 3 && this.commonService.IsNumber(dateParts[0]) && this.commonService.IsNumber(dateParts[1]) && this.commonService.IsNumber(dateParts[2])){
                return { day: this.commonService.ToInteger(dateParts[0]), month: this.commonService.ToInteger(dateParts[1]), year: this.commonService.ToInteger(dateParts[2]) };
            }
            return null;
        }
    }

    format(date: NgbDateStruct): string {
        let stringDate: string = '';
        if(date){
            stringDate += this.commonService.IsNumber(date.day) ? this.commonService.PadNumber(date.day) + this.userService.GetDateSeparator() : '';
            stringDate += this.commonService.IsNumber(date.month) ? this.commonService.PadNumber(date.month) + this.userService.GetDateSeparator() : '';
            stringDate += date.year;
        }
        return stringDate;
    }
}